// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gameMenuModal_gameModal__26lEJ {\n  display: flex;\n  text-transform: uppercase;\n  min-height: 0;\n}\n.gameMenuModal_gameModal__26lEJ .gameMenuModal_content__ksewd {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  text-align: center;\n  width: 100%;\n  align-items: center;\n  padding: 28px 48px 20px;\n}\n.gameMenuModal_gameModal__26lEJ button {\n  padding: 11px 43px;\n  margin-bottom: 16px;\n  min-width: 110px;\n}\n.gameMenuModal_gameModal__26lEJ button:last-child {\n  margin-bottom: 0;\n}", ""]);
// Exports
exports.locals = {
	"gameModal": "gameMenuModal_gameModal__26lEJ",
	"content": "gameMenuModal_content__ksewd"
};
module.exports = exports;
